import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';
import { ProvidersService } from '../../../services/providers.service';
import {AuthorizersDetailComponent} from '../authorizers-detail/authorizers-detail.component';

import * as decode from 'jwt-decode';

@Component({
  selector: 'app-authorizers',
  templateUrl: './authorizers.component.html',
  styleUrls: ['./authorizers.component.scss']
})
export class AuthorizersComponent implements OnInit {
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  loadBtn = true;
  listUsersAsigned: any = [];
  listUsersNotAsigned: any = [];
  listUsersPortal: any = [];

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('ADMINAUTHTIT');
    this.getUsersAuth();
  }

  ngOnInit() {
  }

  getUsersAuth(){
    this.groupService.getUsersAuth(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      this.listUsersAsigned = data['usuariosAsignados'];
      this.listUsersNotAsigned = data['pendientesPorAsignar'];
      this.listUsersPortal = data['usuariosPortal'];
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      //this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  reasign(idx){
    const dialogRef = this.dialog.open(AuthorizersDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'reassign', userId: this.userId, userToken: this.userToken, listUsersPortal: this.listUsersPortal, info: this.listUsersAsigned[idx] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result.pendientesPorAsignar && result.usuariosAsignados){
          this.listUsersNotAsigned = result.pendientesPorAsignar;
          this.listUsersAsigned = result.usuariosAsignados;
        }else{
          this.getUsersAuth();
        }
      }
    });
  }

  asign(idx){
    const dialogRef = this.dialog.open(AuthorizersDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'assign', userId: this.userId, userToken: this.userToken, listUsersPortal: this.listUsersPortal, info: this.listUsersNotAsigned[idx] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(result.pendientesPorAsignar && result.usuariosAsignados){
          this.listUsersNotAsigned = result.pendientesPorAsignar;
          this.listUsersAsigned = result.usuariosAsignados;
        }else{
          this.getUsersAuth();
        }
      }
    });
  }

}
